import { ReactNode } from 'react'
import styled from 'styled-components'
import { Box, Text } from '@machobear/design-system'

const Counter = styled.span`
  position: absolute;
  font-size: 14px;
  line-height: 24px;
  right: -10px;
  top: -10px;
  z-index: 100;
  color: white;
  font-weight: 700;
  background-color: #fe5f55;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  text-align: center;
`

interface Props {
  icon: ReactNode
  text: string
  counter?: number
  tone?: 'disabled' | 'formAccent'
  onClick?: () => void
  disabled?: boolean
}

export const Action = ({
  icon,
  text,
  onClick,
  tone = 'formAccent',
  counter = 0,
  disabled
}: Props) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="flexStart"
    alignItems="center"
    gap="xxsmall"
    position="relative"
    cursor={disabled ? 'default' : 'pointer'}
    style={{ overflowY: 'visible' }}
  >
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      border={disabled ? undefined : 'borderNeutralLight'}
      borderRadius="standard"
      cursor={disabled ? 'default' : 'pointer'}
      padding="none"
      margin="none"
      style={{
        boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 0.05)',
        backgroundColor: disabled ? '#EAECF1' : 'white',
        width: '80px',
        height: '52px'
      }}
      onClick={disabled ? undefined : onClick}
    >
      {icon}
    </Box>

    <Text
      weight="strong"
      tone={disabled ? 'disabled' : tone}
      size="xsmall"
      align="center"
      baseline={false}
    >
      {text}
    </Text>

    {counter > 0 && <Counter>{counter}</Counter>}
  </Box>
)
